import React from "react";

interface TrainingModeBannerProps {
  rounded?: boolean;
}

export const TrainingModeBanner = ({ rounded }: TrainingModeBannerProps) => {
  return (
    <div style={{ width: '100%', height: '56px', backgroundColor: '#dc3545', borderRadius: rounded ? '5px' : undefined }} className='d-flex align-items-center justify-content-center mb-2'>
      <h2 className='mb-0' style={{ fontWeight: 'bold', color: 'white' }}>TRAINING MODE</h2>
    </div>
  )
};
